import {Club} from './club/club';
import {Status} from './reusables/status';
import {CustomerStatusTranslationsService} from 'src/app/shared/translations';

/**
 * Blueprint for the user entity.
 */
export class User {
  public id: number;
  public username: string;
  public firstName: string;
  public lastName: string;
  public email: string;
  public type: string;
  public enabled: boolean;
  public tokenLifetime?: number;
  public clubs: Array<Club> = [];
  public forcePasswordChange: boolean;
  public status: Status;

  public statuses: Array<Status> = [
    {value: true, status: this.statusTranslations.i18nActiveStatus, class: 'esf-tag--success'},
    {value: false, status: this.statusTranslations.i18nLockedStatus, class: 'esf-tag--alert'}
  ];

  constructor(user: any, private statusTranslations: CustomerStatusTranslationsService) {
    this.id = user.id;
    this.username = user.username;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.email = user.email;
    this.type = user.type;
    this.enabled = user.enabled;
    this.tokenLifetime = user.tokenLifetime;
    this.clubs = user.clubs;
    this.forcePasswordChange = user.forcePasswordChange;
    this.status = this.translatedCustomerStatus();
  }

  public translatedCustomerStatus(): Status {
    const translatedStatus = this.statuses.find((status: any) => this.enabled === status.value);
    return translatedStatus ? new Status(translatedStatus) : null;
  }

  public get statusCssClass(): any {
    const newStatus = this.statuses.find((status: any) => this.enabled === status.value);
    return newStatus.class;
  }

  public get displayClubName(): any {
    if (this.clubs.length) {
      if (this.clubs.length === 1) {
        return this.clubs[0].name;
      } else {
        return 'Multiple Clubs';
      }
    } else {
      if (this.type === 'Admin' || this.type === 'CountryManager') {
        return 'Multiple Clubs';
      } else {
        return '';
      }
    }
  }
}
